import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import * as fromContactUs from '../contact-us/reducers/contact-us.reducer';
import {ContactUsEffects} from './effects/contact-us.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('contactUs', fromContactUs.reducer),
    EffectsModule.forFeature([ContactUsEffects])
  ]
})
export class ContactUsModule { }
